import React, {useMemo} from "react";
import { STATUS_CODES } from "constants/global";
import { useLocation } from "react-router";

const PageNotFound = () => {
  const isHash = useLocation().hash.split("#")[1] || '404';
  const content = useMemo(() => {
    switch(isHash) {
      case STATUS_CODES[401]:
        return 'Unauthorized';
      case STATUS_CODES[403]:
        return 'Forbidden';
      case STATUS_CODES[404]:
        return 'Page Not Found';
      case STATUS_CODES[429]:
        return 'Too Many Requests';
      case STATUS_CODES[500]:
        return 'Internal Server Error';
      case STATUS_CODES[512]:
        return <>現在表示できません。<br/>詳細はお問い合わせください。</>;
      default:
        return '';
    }
  });

  return (
    <div className="sorry d-flex flex-column align-items-center justify-content-center w-75 mx-auto h-auto">
      {isHash !== STATUS_CODES[512] &&
        <h1 className="display-1 fw-bold text-center fs-404 fw-600 text-brown">{isHash}</h1>
      }
      <div className="fs-24 fs-sm-20 text-center text-brown fw-600">{content}</div>
      <a href="/" className="btn-custom brown mt-5">TOP</a>
    </div>
  );
};

export default PageNotFound;
